import { HttpService } from '@/services/http.service';

export default {
    async comments(postId) {
        return await HttpService.httpGet(`/comments/${postId}`);
    },

    async store(comment) {
        return await HttpService.httpPost('/comments/store/', comment);
    },
}
